import { useState, useEffect, useCallback } from 'react';

export const useUnitState = (searchParams, setSearchParams) => {
  const [unit, setUnit] = useState(searchParams.get("unit") || "meters");

  useEffect(() => {
    setSearchParams(params => {
      params.set("unit", unit);
      return params;
    });
  }, [unit, setSearchParams]);

  const toggleUnit = useCallback(() => {
    setUnit(prev => prev === "meters" ? "yards" : "meters");
  }, []);

  return { unit, toggleUnit };
}; 